import { render, staticRenderFns } from "./tableVirtualConversationDetails.vue?vue&type=template&id=a1d71cb4&scoped=true"
import script from "./tableVirtualConversationDetails.vue?vue&type=script&lang=js"
export * from "./tableVirtualConversationDetails.vue?vue&type=script&lang=js"
import style0 from "./tableVirtualConversationDetails.vue?vue&type=style&index=0&id=a1d71cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d71cb4",
  null
  
)

export default component.exports